export default __webpack_public_path__ + "static/media/chrome.6b3be410.svg";